import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";
import {
  VEHICLE_VALUATION_VEHICLE_SELECTION_API_PATH,
  VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION,
} from "./use-vehicle-valuation-vehicle-selection.query";

const VEHICLE_RESOURCE = "vehicle" as const;

export type VehicleValuationSelectVehicleBody =
  paths[typeof VEHICLE_VALUATION_VEHICLE_SELECTION_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type VehicleValuationSelectVehicleResponse =
  paths[typeof VEHICLE_VALUATION_VEHICLE_SELECTION_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

interface VehicleValuationSelectVehicleVariables {
  uuid: string;
  body: VehicleValuationSelectVehicleBody;
}

export function useVehicleValuationSelectVehicleMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationSelectVehicleResponse, Error, VehicleValuationSelectVehicleVariables>({
    mutationFn: async ({ uuid, body }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationSelectVehicleResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/${VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION}`,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
          refetchType: "inactive",
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
          refetchType: "inactive",
        }),
      ]);
    },
  });
}
